// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-1ca4a294] .modal-backdrop{background-color:hsla(0,0%,100%,.8)!important}[data-v-1ca4a294] .modal-content{border:1px solid rgba(7,9,25,.125);box-shadow:0 0}[data-v-1ca4a294] .modal-header{border-bottom:0}.modal-congrat__description[data-v-1ca4a294]{font-size:13.81px;color:rgba(7,9,25,.5)}.modal-congrat__button[data-v-1ca4a294]{border-top:1px solid #eeeff8}", ""]);
// Exports
module.exports = exports;
